import React from "react";
import Export, { REPORT_TYPES } from "Export";

const getKbartGenerationUrl = orgId =>
  `${process.env.REACT_APP_CATALOG_BASE_URL}/kbart/organizations/${orgId}`;
const KbartExport = () => {
  return (
    <Export
      reportType={REPORT_TYPES.KBART}
      getExportGenerationUrl={getKbartGenerationUrl}
    />
  );
};

export default KbartExport;
